<template>
  <div class="layout">
    <el-container>
      <el-header>
        <el-row>
          <el-col :span="6">
            <div class="flex-box logo-box color-base">
              <img
                style="width: 28px;border-radius: 4px"
                src="../../assets/logo.png"
              />
              玄综文化
            </div>
          </el-col>
          <el-col :span="12">
            <my-menu v-model="menu"></my-menu>
          </el-col>
          <el-col :span="6"></el-col>
        </el-row>
      </el-header>
      <div class="main-content">
        <router-view></router-view>
      </div>
    </el-container>
  </div>
</template>

<script>
import MyMenu from "@/components/my-menu.vue";

export default {
  name: "HomeView",
  components: { MyMenu },
  data() {
    return {
      menu: "/",
    };
  },
};
</script>

<style lang="less" scoped>
.layout {
  .el-header {
    background: #fffdfa;
    position: sticky;
    top: 0;
    z-index: 9999;
  }

  .logo-box {
    font-size: 24px;
    font-weight: bold;
    height: 60px;
    letter-spacing: 2px;

    img {
      height: 28px;
      margin-right: 8px;
      pointer-events: none;
    }
  }
}
</style>
